module.exports = [
    {
        "creatorType": "author",
        "localized": "Author"
    },
    {
        "creatorType": "contributor",
        "localized": "Contributor"
    },
    {
        "creatorType": "editor",
        "localized": "Editor"
    },
    {
        "creatorType": "seriesEditor",
        "localized": "Series Editor"
    },
    {
        "creatorType": "translator",
        "localized": "Translator"
    }
]


//////////////////
// WEBPACK FOOTER
// ./static/creatorFields/books.js
// module id = Iwc7
// module chunks = 1